export default __webpack_public_path__ + "static/media/screen2.a03be30d.png";